import styled from 'styled-components';

export const StyledOrderSummary = styled.section`
  background-color: ${props => props.theme.colors.neutral.white};
  border-radius: 24px;
  padding: ${props => props.theme.spacing(7, 4, 4, 4)};
  max-width: 350px;
  width: 100%;
`;

export const AnimatedLoaderContainer = styled.div`
  margin: 0 auto;
  width: 300px;
`;

export const OrderSummaryPetInfo = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const StarterBoxInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h2`
  ${props => props.theme.fontFamily.base}
  color: ${props => props.theme.colors.text.primary};
  text-align: center;
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const StarterBoxHeader = styled.h3`
  ${props => props.theme.typography.heading6};
`;

export const StarterBoxInfoLine = styled.p`
  ${props => props.theme.typography.body};
`;

export const LightText = styled.span`
  color: ${props => props.theme.colors.text.secondary};
`;

export const AddPetLine = styled.div`
  padding: ${props => props.theme.spacing(2, 0)};
  a {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: grid;
  margin: ${props => props.theme.spacing(3, 0, 4)};
`;

export const TermsAndConditions = styled.div`
  ${props => props.theme.typography.label};
  padding: ${props => props.theme.spacing(1)};
  color: ${props => props.theme.colors.text.secondary};
`;

export const TermsAndConditionsLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;

export const AgreementsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${props => props.theme.spacing(3)};
  ${props => props.theme.typography.body}
  padding: ${props => props.theme.spacing(4)};
`;

export const StyledCopy = styled.div`
  ${props => props.theme.typography.label};
  text-align: center;
`;

export const StyledCheckoutText = styled.span``;
